import { LoginStatusEnum } from '../enums/login-status.enum';
import { LoginStatusDetailsModel } from '../models/login-status-details.model';

export const LoginStatusDetailsRecord: Record<LoginStatusEnum, LoginStatusDetailsModel> = {
  [LoginStatusEnum.Checking]: {
    title: 'Signing you in',
    text: 'This only takes a moment',
    imageUrl: '/assets/images/sign-in/sign-in-code-checking-loop.svg',
  },
  [LoginStatusEnum.Success]: {
    title: 'You’re all set',
    text: 'Just getting things ready for you',
    imageUrl: '/assets/images/sign-in/sign-in-code-signed-in.svg',
  },
  [LoginStatusEnum.Expired]: {
    title: 'Your link has expired or is invalid',
    text: 'Request a new sign-in email and we’ll send it straight over.',
    imageUrl: '/assets/images/sign-in/sign-in-code-expired.svg',
  },
  [LoginStatusEnum.Error]: {
    title: 'Something went wrong',
    text: 'We couldn’t sign you in. Please try again.',
    imageUrl: '/assets/images/sign-in/sign-in-code-error.svg',
  },
};
